enum FlexGridColumnTypeEnum {
    String = 'String',
    Int32 = 'Int32',
    Boolean = 'Boolean',
    Decimal = 'Decimal',
}

export default FlexGridColumnTypeEnum;
